import { Phone, Mail, MapPin, CreditCard, Landmark } from "lucide-react";
import { Link } from "react-router-dom";
import { useShop } from "@/shop/ShopContext";
import { Logo } from "@/components/Header";

const Footer = () => {
  const { config } = useShop();
  return (
    <footer className="border-t border-white/10 bg-[#08090C]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-neutral-400">
              Ricambi auto, moto e scooter in pronta consegna. Ricambi originali e compatibili di qualità,
              con spedizione espressa in tutta Italia.
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.3em] text-[#FF5500]">Contatti</h4>
            <ul className="mt-4 space-y-3 text-sm text-neutral-300">
              <li>
                <a href={config.phone_href} className="flex items-center gap-2.5 text-lg font-semibold text-neutral-100 transition-colors hover:text-[#FF5500]" data-testid="footer-phone-link">
                  <Phone className="h-4 w-4 text-[#FF5500]" />
                  {config.phone}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 text-[#FF5500]" />
                Ordini e disponibilità via telefono
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin className="h-4 w-4 text-[#FF5500]" />
                Spedizioni in tutta Italia
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.3em] text-[#FF5500]">Pagamenti accettati</h4>
            <ul className="mt-4 space-y-3 text-sm text-neutral-300">
              <li className="flex items-center gap-2.5">
                <CreditCard className="h-4 w-4 text-[#FF5500]" />
                Carta di credito / debito (Visa, Mastercard)
              </li>
              {config.bonifico_enabled && (
                <li className="flex items-center gap-2.5">
                  <Landmark className="h-4 w-4 text-[#FF5500]" />
                  Bonifico bancario anticipato
                </li>
              )}
            </ul>
            <Link
              to="/catalogo"
              className="mt-6 inline-block rounded-full border border-[#FF5500]/50 px-5 py-2.5 font-display text-xs uppercase tracking-[0.2em] text-[#FF5500] transition-colors hover:bg-[#FF5500] hover:text-white"
              data-testid="footer-catalog-link"
            >
              Vai al catalogo
            </Link>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-neutral-500 sm:flex-row">
          <span>© 2026 Delivery Ricambi — Tutti i diritti riservati</span>
          <span className="font-mono">
            Assistenza ordini: <span className="text-[#FF5500]">{config.phone}</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
